// Dependencies
import React from "react";
import TableRow from './tableRow'

const TableEditableEmptyRow = (props) => {
  const [rowNew, setRowNew] = React.useState([]); 
  
  React.useEffect(() => {
    let rowNew_temp = props.new_row.slice()
    rowNew_temp[0].value = props.numberOfRow
    setRowNew(rowNew_temp)
  }, [props.new_row]);

  return (
    <TableRow 
        onBlur={(e) => props.onBlur(e)}
        rowsData={{row: rowNew, id: "", temp_id: props.temp_id}}
        onChange={(rowsData, i, value, temp_id) => props.onChange(rowsData, i, value, temp_id)}
        numberOfRow={props.numberOfRow}
        refInput={props.refInput}
      />
  );
};

export default TableEditableEmptyRow;

